<template>
<div :class="className" @click.stop="handleClick($event)">
    <div :class="['checkbox-box', 'primary-text', { 'checked': checked }]">
        <i class="d-ib material-icons">check</i>
    </div>

    <slot></slot>
</div>
</template>

<script>
export default {
    name: "checkbox",

    props: {
        alone: {
            default: false,
            type: Boolean
        },

        checked: {
            default: false,
            type: Boolean
        },

        center: {
            default: false,
            type: Boolean
        },

        disabled: {
            default: false,
            type: Boolean
        }
    },

    computed: {
        className: function () {
            let classes = [
                "checkbox"
            ]

            if (this.alone) {
                classes.push("alone")
            }

            if (this.center) {
                classes.push("center")
            }

            if (this.disabled) {
                classes.push("disabled")
            }

            return classes
        }
    },

    methods: {
        handleClick: function (ev) {
            if (!this.disabled) {
                this.$emit("click")
            }
        }
    }
}
</script>

<style>
.checkbox {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    opacity: 1.0;
    transition: all 0.15s ease;
    user-select: none;
}

.checkbox.disabled {
    cursor: default;
    opacity: 0.75;
}

.checkbox.center {
    justify-content: center;
}

.checkbox.alone .checkbox-box {
    margin: 0;
}

.checkbox-box {
    align-items: center;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
    display: flex;
    flex: 0 0 18px;
    justify-content: center;
    height: 18px;
    margin-right: 10px;
    transition: all 0.15s ease;
    width: 18px;
}

.checkbox.disabled .checkbox-box {
    background: #efefef;
}

.checkbox-box i,
.checkbox-box svg {
    opacity: 0.0;
    transition: all 0.15s ease;
}

.checkbox-box.checked {
    box-shadow: 0 2px 2px 0 currentColor, 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.checkbox-box.checked i,
.checkbox-box.checked svg {
    opacity: 1.0;
}
</style>



// WEBPACK FOOTER //
// src/components/Checkbox.vue